import type { JiraSideNav } from '@post-office/placement-create-pipeline/pipes';

import { createClientPipeline } from '@post-office/placement-create-pipeline/create-pipeline';

import { type MessageTemplateContext } from '@post-office/browser--growth-starburst/twc-sidenav-banner/types';

import { type JSX } from 'react/jsx-runtime';

import { type ExperimentArm } from './hydrate';

export type HydrationResult = {
	product: MessageTemplateContext['product'];
	redirectTo: 'jira' | 'confluence';
	onboardingUrl: string;
	messageInstanceId: string;
	locale: string;
	arm: ExperimentArm;
	recommendedApp?: 'confluence' | 'jira' | 'loom';
	actionTier?: 'high' | 'medium' | 'low';
	experimentKey?: string;
	targetTenantId?: string;
	collectionEntitlementId?: string;
};

type Pipe = JiraSideNav<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

const clientPipeline = createClientPipeline<Pipe>();

export const createRender: <
	U extends (
		renderProps: Omit<HydrationResult, 'postOffice'> & {
			onDismissed: () => void;
		},
	) => JSX.Element | null,
>(
	render: U,
) => (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = clientPipeline.createRender;
